<template>
  <div class="wrapper" v-on:touchmove="handleTouchMove">
    <div v-if="items?.length" class="item item-type">
      <div class="title required">选择专题</div>
      <div class="btn-group">
        <van-button @click="handleTypeSelect(it, index)" class="btn"
          :class="targetActiveIndex === index ? 'active' : ''" v-for="(it, index) in items">
          {{ it.title }}
        </van-button>
      </div>
    </div>
    <div class="item item-link">
      <div class="title required">快手作品链接 {{ isPC ? `( 请前往快手APP端复制 )` : '' }}</div>
      <div class="neck">
        <div class="left">
          <span>在快手发布30秒以上的作品并带上{{ topics?.length }}个话题
            {{ topicsStr }} 才能视为参加哦。</span>
          <van-button plain class="copy-btn" @click="handleCopy">
            <img style="width: 0.24rem; height: 0.24rem; margin-right: 0.06rem"
              src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/b7b9502a-0f86-402b-b181-ee9a998a7ba0.png" />
            点击复制
          </van-button>
        </div>
        <div class="right">
          <Button type="plain" size="normal" @click="handlePublish">
            <div class="pub-btn-content">
              <img
                src="https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/78b86433-b461-4ef6-8788-54c49d176b97.png" />
              <span style="font-weight: 500">去发布</span>
            </div>
          </Button>
        </div>
      </div>
      <van-field v-model="modelValue.photoUrl" type="textarea" class="kl-field2" placeholder="请填写快手作品链接" ref="filedEle1"
        @touchmove="(e: any) => e?.stopPropagation()" />
    </div>
    <div class="item item-title">
      <div class="title required">作品标题</div>
      <van-field v-model="modelValue.photoTitle" type="textarea" class="kl-field" placeholder="请填写快手作品标题" maxlength="30"
        show-word-limit ref="filedEle2" />
    </div>
    <div class="item item-desc">
      <div class="title required">作品简介</div>
      <van-field v-model="modelValue.photoDescription" type="textarea" class="kl-field3" placeholder="请填写快手作品简介"
        maxlength="200" show-word-limit ref="filedEle3" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { Button as VanButton, Field as VanField, showToast } from "vant";
import Button from "../common/button.vue";
import useDevice from "../common/useDevice";
import { ContributeCount, SubmitContributeParams } from "../common/api/request";
import ClipboardJS from "clipboard";
import kylogger from "@ky/sdk/dist/log/kylogger";
import open from "@ky/sdk/dist/open";
const filedEle1 = ref<HTMLInputElement | null>(null);
const filedEle2 = ref<HTMLInputElement | null>(null);
const filedEle3 = ref<HTMLInputElement | null>(null);
const props = withDefaults(
  defineProps<{
    items: ContributeCount["expertReview"];
    topics?: string[];
    modelValue: SubmitContributeParams;
  }>(),
  {
    items: () => [],
    modelValue: () =>
      ({
        contestChannel: "expertReview",
        secondContestChannel: 1,
      }) as SubmitContributeParams,
  },
);

type Event = {
  (e: "update:modelValue", value: SubmitContributeParams): void;
};

const emit = defineEmits<Event>();

const targetActiveIndex = computed(() => {
  const activeIndex = props?.modelValue?.secondContestChannel ?? 0;
  const targetIndex = props?.items?.findIndex((it) => it?.code === activeIndex);
  return targetIndex;
});

const topicsStr = computed(() => props?.topics?.join(" ") ?? "");
const { isPC, isKyMobile, isAndroid, isKs } = useDevice();

const handleTypeSelect = (
  item: ContributeCount["expertReview"][number],
  index: number,
) => {
  emit("update:modelValue", {
    ...props?.modelValue,
    secondContestChannel: item.code,
  });
};

const handleCopy = () => {
  const clipboard = new ClipboardJS(".copy-btn", {
    text: () => topicsStr.value,
  });
  clipboard.on("success", () => {
    showToast({
      message: '<div style=" padding:0.2rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">复制成功</div>',
      type: 'html'  //所加样式名
    });
  });
  clipboard.on("error", () => {
    showToast({
      message: '<div style=" padding:0.2rem 0.4rem;color:rgba(255,255,255,0.9);font-size: 0.26rem; border-width:0.5px; border-style: solid; border-color: rgba(255,255,255,0.08);background-color: rgba(34,34,34,0.95);border-radius: 16rem;">复制失败</div>',
      type: 'html'  //所加样式名
    });
  });
};

const handlePublish = () => {
  kylogger.collect("CLICK", "TO_PUBLISH", {
    track: props?.modelValue?.secondContestChannel ?? 0
  });
  if (isPC.value) {
    window.open(`https://cp.kuaishou.com/article/publish/video`, "_blank");
  } else if (isKyMobile.value || isKs.value) {
    const url = isAndroid.value
      ? `kwai://post?tab=photoTake&returnToWeb=true&initialCaption=${encodeURIComponent(
        topicsStr.value,
      )}`
      : `kwai://recordalbum?initialCaption=${encodeURIComponent(
        topicsStr.value,
      )}`;
    open(url);
  } else {
    window.open(`https://cp.kuaishou.com/article/publish/video`, "_blank");
  }
};

function handleTouchMove() {
  filedEle1.value?.blur?.();
  filedEle2.value?.blur?.();
  filedEle3.value?.blur?.();
}
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  flex: 1;
  overflow-y: auto;

  .title {
    display: inline-block;
    font-size: 0.32rem;
    font-weight: 400;
    color: #fff;
    line-height: 0.48rem;
    margin-bottom: 0.24rem;

    @media screen and (max-width: 1360px) {
      font-size: 0.28rem;
      font-weight: 500;
      line-height: 0.4rem;
      margin-bottom: 0.16rem;
    }
  }

  .neck {
    display: flex;
    align-items: flex-start;
    margin-bottom: 0.24rem;

    .left {
      flex: 1;
      font-size: 0.26rem;
      line-height: 0.36rem;
      color: rgba(255, 255, 255, 0.5);

      @media screen and (max-width: 1360px) {
        font-size: 0.24rem;
        line-height: 0.36rem;
        font-weight: 400;
      }
    }

    .right {
      margin-left: 0.66rem;

      @media screen and (max-width: 1360px) {
        margin-left: 0.16rem;
        margin-top: 0.04rem;
      }
    }

    .copy-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      margin: 0;
      height: auto;
      color: rgba(255, 255, 255, 0.9);
      font-size: 0.22rem;
      font-weight: 400;
      line-height: 0.36rem;
      border: none;
      vertical-align: middle;
      background-color: transparent;

      :deep(.van-button__text) {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .pub-btn-content {
      display: flex;
      align-items: center;
      justify-content: center;

      >img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.04rem;

        @media screen and (max-width: 1360px) {
          width: 0.32rem;
          height: 0.32rem;
        }
      }
    }
  }

  .btn-group {
    width: 100%;
    overflow-x: auto;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    &::-webkit-scrollbar {
      display: none;
    }

    .btn {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 0.8rem;
      padding: 0 1.04rem;
      border-radius: 0.16rem;
      color: rgba(255, 255, 255, 0.9);
      border: 0.01rem solid rgba(255, 255, 255, 0);
      background-color: rgba(255, 255, 255, 0.06);

      @media screen and (max-width: 1360px) {
        padding: 0 0.52rem;
      }

      @media screen and (max-width: 750px) {
        padding: 0 0;
        flex: 1;
      }

      &:not(:last-of-type) {
        margin-right: 0.16rem;
      }

      &.active {
        background-color: rgba(255, 255, 255, 0.2);
      }
    }
  }

  .item {
    margin-bottom: 0.32rem;

    @media screen and (max-width: 1360px) {
      margin-bottom: 0.5rem;
    }

    &-link {

      .kl-field {
        @media screen and (max-width:1360px) {
          max-height: 2.2rem;
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }

      }
    }

    &-title {
      .kl-field {
        min-height: 1.28rem;
      }

      :deep(.van-field__word-limit) {
        align-self: flex-end;
        position: absolute;
        bottom: -20px;
        right: 0px;
      }

      :deep(.van-field) {
        &__value {
          .van-field__body {
            align-self: center !important;
          }
        }

        @media screen and (max-width: 1360px) {
          &__control--min-height {
            min-height: 0;
          }
        }
      }
    }

    &-desc {
      :deep(.van-field__word-limit) {
        align-self: flex-end;
        position: absolute;
        bottom: 0px;
        right: 0px;
      }
    }
  }

  .kl-field {
    width: 100%;
    min-height: 1.68rem;
    background-color: rgba(255, 255, 255, 0.04);
    border-radius: 0.16rem;
    padding: 0.24rem;
    padding-bottom: 0.5rem;

    :deep(.van-field) {
      &__control {
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;

        &::placeholder {
          color: rgba(255, 255, 255, 0.3);
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &__value {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .van-field__body {
          flex: 1;
          align-self: flex-start;
        }
      }
    }
  }

  .kl-field2 {
    width: 100%;
    min-height: 1.68rem;
    background-color: rgba(255, 255, 255, 0.04);
    border-radius: 0.16rem;
    padding: 0.24rem;
    padding-bottom: 0.3rem;

    :deep(.van-field) {
      &__control {
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;

        &::placeholder {
          color: rgba(255, 255, 255, 0.3);
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &__value {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .van-field__body {
          flex: 1;
          align-self: flex-start;
        }
      }
    }
  }

  .kl-field3 {
    width: 100%;
    min-height: 2.55rem;
    margin-bottom: 1rem;
    background-color: rgba(255, 255, 255, 0.04);
    border-radius: 0.16rem;
    padding-bottom: 0.2rem;

    :deep(.van-field) {
      &__control {
        color: rgba(255, 255, 255, 0.9);
        font-size: 0.28rem;
        font-weight: 400;
        line-height: 0.4rem;
        height: 1.65rem;

        &::placeholder {
          color: rgba(255, 255, 255, 0.3);
        }

        &::-webkit-scrollbar {
          display: none;
        }
      }

      &__value {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .van-field__body {
          flex: 1;
          align-self: flex-start;
        }
      }
    }
  }

  .required {
    position: relative;

    &::after {
      content: "*";
      color: #f7365d;
      position: absolute;
      right: -0.2rem;
      top: 0;
    }
  }
}
</style>
